import React from 'react';
import { Box, Container, Typography, Link, Stack, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const HomeFooter = () => {
  const { loginWithRedirect } = useAuth();

  const handleLogin = () => {
    const hasConsent = localStorage.getItem('has_consented');
    loginWithRedirect({
      authorizationParams: {
        ...(hasConsent ? {} : { prompt: 'consent' }),
        scope: 'openid profile email offline_access',
        audience: process.env.REACT_APP_AUDIENCE,
      },
    });

    if (!hasConsent) {
      localStorage.setItem('has_consented', 'true');
    }
  };

  const handleSignup = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
        prompt: 'consent',
        scope: 'openid profile email offline_access',
        audience: process.env.REACT_APP_AUDIENCE,
      },
    });
  };

  const accountLinkSx = {
    justifyContent: 'flex-start',
    width: 'fit-content',
    textAlign: 'left',
  };

  return (
    <Box
      component="footer"
      sx={{
        mt: 0,
        py: { xs: 5, md: 6 },
        backgroundColor: 'background.default',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 4, md: 6 }}
          justifyContent="space-between"
        >
          <Box sx={{ maxWidth: 360 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
              itclarifies
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Practice decisions that matter
            </Typography>
          </Box>

          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 5 }}>
            <Stack spacing={1}>
              <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
                Product
              </Typography>
              <Link href="/#how-it-works" underline="hover" color="primary.dark" variant="body2">
                How it works
              </Link>
              <Link href="/#for-organizations" underline="hover" color="primary.dark" variant="body2">
                For organizations
              </Link>
              <Link href="/#why-itclarifies" underline="hover" color="primary.dark" variant="body2">
                Why Itclarifies
              </Link>
              <Link href="/#pricing" underline="hover" color="primary.dark" variant="body2">
                Pricing
              </Link>
            </Stack>

            <Stack spacing={1}>
              <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
                Account
              </Typography>
              <Link
                component="button"
                type="button"
                onClick={handleLogin}
                underline="hover"
                color="primary.dark"
                variant="body2"
                sx={accountLinkSx}
              >
                Log in
              </Link>
              <Link
                component="button"
                type="button"
                onClick={handleSignup}
                underline="hover"
                color="primary.dark"
                variant="body2"
                sx={accountLinkSx}
              >
                Sign up
              </Link>
            </Stack>

            <Stack spacing={1}>
              <Typography variant="caption" sx={{ fontWeight: 700, letterSpacing: 0.4 }}>
                Legal
              </Typography>
              <Link component={RouterLink} to="/terms" underline="hover" color="primary.dark" variant="body2">
                Terms &amp; Conditions
              </Link>
              <Link component={RouterLink} to="/privacy-policy" underline="hover" color="primary.dark" variant="body2">
                Privacy Policy
              </Link>
              <Link component={RouterLink} to="/dpa" underline="hover" color="primary.dark" variant="body2">
                Data Processing Agreement
              </Link>
            </Stack>
          </Stack>
        </Stack>

        <Divider sx={{ my: 3 }} />

        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} Itclarifies AB. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default HomeFooter;
